import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {DataService} from 'projects//paid_ukr/src/app/components/publications/data.service';
import {tr} from 'date-fns/locale';

@Component({
    selector: 'app-publications',
    templateUrl: './publications.component.html',
    styleUrls: ['./publications.component.scss']
})
export class PublicationsComponent implements OnInit {
    loading = true;
    posts: any[];
    @Output() loaded: EventEmitter<boolean> = new EventEmitter();

    constructor(
        private service: DataService
    ) {
    }

    ngOnInit(): void {
        this.service.fetchData()
            .subscribe((res: any[]) => {
                this.posts = res;
                this.loading = false;
                this.loaded.emit(true);
            }, () => {
                this.loaded.emit(true);
                this.loading = false;
            });
    }


    get showBlock() {
        return this.posts?.length && !this.loading;
    }

    findElementByHeaderPosition(position: number) {
        return this.posts.find(el => el.position === position.toString());
    }
}
